import type { StoreApi, UseBoundStore } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { safeLocalStorage } from '@/lib/browser/safe-local-storage';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

interface TradeTermsAcceptanceState {
  acceptedUserIds: Record<string, true>;
  hasAccepted: (userId: string) => boolean;
  markAccepted: (userId: string) => void;
}

export const useTradeTermsAcceptanceStore: UseBoundStore<StoreApi<TradeTermsAcceptanceState>> =
  createTrackedStore<TradeTermsAcceptanceState>('useTradeTermsAcceptanceStore')(
    persist(
      (set, get) => ({
        acceptedUserIds: {},
        hasAccepted: (userId: string): boolean => Boolean(get().acceptedUserIds[userId]),
        markAccepted: (userId: string): void => {
          if (get().acceptedUserIds[userId]) return;
          set((state) => ({
            acceptedUserIds: { ...state.acceptedUserIds, [userId]: true },
          }));
        },
      }),
      {
        name: 'morfi-trade-terms-acceptance',
        storage: createJSONStorage(() => safeLocalStorage),
      },
    ),
  );
